export default "__VITE_ASSET__BA7lvKu9__"